import { render, staticRenderFns } from "./EnterTunelMain.vue?vue&type=template&id=bf978db2&v-slot%3Ano-data=true"
import script from "./EnterTunelMain.vue?vue&type=script&lang=js"
export * from "./EnterTunelMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports